import { createFeatureSelector, createSelector } from '@ngrx/store';

export const selectPrecheckin = createFeatureSelector<any>('precheckin');

export const selectPrecheckinState = createSelector(
    selectPrecheckin,
    (state: any) => state,
);
